import { Component, DestroyRef, inject } from '@angular/core';
import {  RouterModule, RouterOutlet } from '@angular/router';
import { SeoService } from './services/meta.service';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './common/components/footer/footer.component';
import { HeaderComponent } from './common/components/header/header.component';
import { SidebarComponent } from './common/components/sidebar/sidebar.component';
import { LoaderComponent } from './common/components/loader/loader.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventService } from './services/event.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    LoaderComponent,
  ],
  providers: [
    ToastrService
  ],

  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'wirefestival-web';
  isLineUp = false;
  private readonly eventService = inject(EventService);
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private readonly seoService: SeoService,
  ) {
    this.seoService.setMetaTags({
      title: 'Wire Festival',
      description: 'Wire Festival',
      keywords: 'Wire Festival'
    });

    this.eventService.getEvent()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.eventService.setCurrentEvent(event);
      });

  }
}
